import type { EditorState } from '../store/editorState';

const getPinnedCompType = (state: EditorState) => state.pinMode.pinnedCompType;
const isOpen = (state: EditorState) => state.pinMode.isOpen;
const getPinPreviewRectStyle = (state: EditorState) =>
  state.pinMode.pinPreviewRectStyle;

export { isOpen, getPinnedCompType, getPinPreviewRectStyle };
